import { api } from "@/api";
import { League } from "@/types/ApiResponses/League";
import { QueryProps } from "@/types/Api";

export interface GetLeaguesNewParams {
  lang?: string;
  name?: string;
  category?: string;
  popular?: boolean;
  mostPopular?: boolean;
  countryId?: number;
  sport?: number;
  sportId?: number;
  sportCategory?: string;
  availableOnly?: boolean;
  includeProviderIds?: boolean;
  includeSuspended?: boolean;
}

export const getLeaguesNew = async (
  props: QueryProps<GetLeaguesNewParams>
): Promise<League[]> => {
  const { sport, availableOnly, sportCategory, ...rest } = props.params || {};
  const params = { ...rest, ...(sport ? { sportId: sport } : {}) };
  const res = await api.client.get(`/leagues-new`, {
    signal: props.signal,
    params,
  });
  return res.data;
};
